import OEColorModel from '../../../lib/color/oe-color-model';

export default class OEThiemeColorModel extends OEColorModel {

    stdColor(alpha, offset = 0) {
        return {x: 0 + offset, y: 20/255.0 + offset, z: 43/255.0 + offset, w: alpha};
    }

    stdBackgroundColor(brightness)  {
        return this.stdColor(0.8);
    }

    stdActiveBackgroundColor(brightness)  {
        return this.stdColor(0.8);
    }

    stdHoverBackgroundColor(brightness)  {
        return this.stdColor(0.8, 0.05);
    }

    stdActiveHoverBackgroundColor(brightness)  {
        return this.stdColor(0.8, 0.05);
    }

    lightBackgroundColor(brightness)  {
        return this.stdColor(0.6);
    }

    lightActiveBackgroundColor(brightness)  {
        return this.stdColor(0.7);
    }

    lightHoverBackgroundColor(brightness)  {
        return this.stdColor(0.7, 0.05);
    }

    lightActiveHoverBackgroundColor(brightness)  {
        return this.stdColor(0.7);
    }

    extraLightBackgroundColor(brightness)  {
        return this.stdColor(0.3);
    }

    extraLightActiveBackgroundColor(brightness)  {
        return this.stdColor(0.4);
    }

    extraLightHoverBackgroundColor(brightness)  {
        return this.stdColor(0.4, 0.05);
    }

    extraLightActiveHoverBackgroundColor(brightness)  {
        return this.stdColor(0.4);
    }

    stdToolbarBackgroundColor(brightness)  {
        return this.stdColor(0.8, 0.05);
    }

    viewBackgroundColor(brightness)  {
        return this.stdColor(0.4);
    }

    startViewBackgroundColor(brightness)  {
        return this.stdColor(0.8);
    }

    /*
    stdBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: opacity} : {x: 0.034, y: 0.1105, z: 0.2, w: opacity};
    }

    stdActiveBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: opacity} : {x: 0.034, y: 0.1105, z: 0.2, w: opacity};
    }

    stdHoverBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.059, y: 0.078, z: 0.1, w: opacity} : {x: 0.084, y: 0.1605, z: 0.25, w: opacity};
    }

    stdActiveHoverBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.059, y: 0.078, z: 0.1, w: opacity} : {x: 0.084, y: 0.1605, z: 0.25, w: opacity};
    }

    lightBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: 0.5} : {x: 0.034, y: 0.1105, z: 0.2, w: 0.5};
    }

    lightActiveBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: 0.6} : {x: 0.068, y: 0.221, z: 0.4, w: 0.6};
    }

    lightHoverBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.059, y: 0.078, z: 0.1, w: 0.6} : {x: 0.118, y: 0.271, z: 0.45, w: 0.6};
    }

    lightActiveHoverBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: 0.6} : {x: 0.068, y: 0.221, z: 0.4, w: 0.6};
    }

    extraLightBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: 0.3} : {x: 0.034, y: 0.1105, z: 0.2, w: 0.3};
    }

    extraLightActiveBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: 0.4} : {x: 0.068, y: 0.221, z: 0.4, w: 0.4};
    }

    extraLightHoverBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.059, y: 0.078, z: 0.1, w: 0.4} : {x: 0.118, y: 0.271, z: 0.45, w: 0.4};
    }

    extraLightActiveHoverBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: 0.4} : {x: 0.068, y: 0.221, z: 0.4, w: 0.4};
    }

    stdToolbarBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.059, y: 0.078, z: 0.1, w: opacity} : {x: 0.0, y: 0.0605, z: 0.15, w: opacity};
    }

    viewBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: 0.4} : {x: 0.034, y: 0.1105, z: 0.2, w: 0.4};
    }

    startViewBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.009, y: 0.028, z: 0.05, w: 0.6} : {x: 0.034, y: 0.1105, z: 0.2, w: 0.6};
    }
    */
}